export default "__VITE_ASSET__BfbL1Qlb__"